/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import clsx from "clsx";
import { MessagePayload, Receipient, Sender } from "../../interfaces/message";
import { USER_KEY } from "../../helpers/constants";
import { AuthenthicatedUserInfo } from "../../interfaces";
import { useFilePicker } from "use-file-picker";
import { useSendMessage } from "../../hooks/message/useSendMessage";
import LoadingIndicator from "../Common/LoadingIndicator";
import { formatTime } from "../../helpers/date_time";
import { useMessageThread } from '../../context/MessageThreadContext';
import { useMessageList } from '../../context/MessageListContext';
import { toast } from 'react-toastify';

const ChatInner = () => {
  const [message, setMessage] = useState<string>("");
  const { submitting, postMessage } = useSendMessage();
  const { messageThread, fetchMessageThread } = useMessageThread();
  const { fetchMessageList } = useMessageList();
  // const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false);
  const [openFileSelector, { errors, plainFiles, clear, filesContent }] =
    useFilePicker({
      multiple: true,
      limitFilesConfig: { max: 5 },
      readAs: "DataURL",
    });

  // const removeFileSelection = (name: string) => {
  //   filesContent.filter((file) => {
  //     return name !== file.name
  //   })
  // }

  useEffect(() => {
    if (errors.length > 0) {
      toast.error(errors[0].name)
      clear()
    }
  }, [errors])

  const user: AuthenthicatedUserInfo = JSON.parse(
    localStorage.getItem(USER_KEY)!
  );

  const sendMessage = async () => {
    const newMessage: MessagePayload = {
      content: message,
      receipient_id: messageThread[0].receipient_id,
      group_key: messageThread[0].group_key,
      title: messageThread[0].title,
      loan_id: messageThread[0].loan_id,
      loan_offer_id: messageThread[0].loan_offer_id,
      attachments: plainFiles,
    };

    // toggleChatUpdateFlat(!chatUpdateFlag);
    await postMessage(newMessage);
    fetchMessageThread(messageThread[0].group_key, false)
    fetchMessageList(false)
    setMessage("");
    clear();
  };

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className="card-body" id="kt_chat_messenger_body">
      <div
        className={clsx("scroll-y me-n5 pe-5", "h-300px h-lg-auto")}
        data-kt-element="messages"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-max-height="auto"
        data-kt-scroll-dependencies={
          "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer"
        }
        data-kt-scroll-wrappers={"#kt_content, #kt_chat_messenger_body"}
        data-kt-scroll-offset="-2px"
      >
        {messageThread.map((message, index) => {
          const sender: Sender = message.sender;
          const receipient: Receipient = message.receipient;
          const isSender = sender.id === +user.user.id!;
          const messageType = isSender ? "out" : "in";
          const state = isSender ? "info" : "primary";
          // const userInfo = userInfos[message.user];
          // const templateAttr = {};
          // if (message.template) {
          //   Object.defineProperty(templateAttr, 'data-kt-element', {
          //     value: `template-${messageType}`,
          //   });
          // }
          const contentClass = `d-flex justify-content-${
            messageType === "in" ? "start" : "end"
          } mb-10`;
          return (
            <div
              key={`message${index}`}
              className={clsx("d-flex", contentClass, "mb-10", {
                "d-none": false,
              })}
            >
              <div
                className={clsx(
                  "d-flex flex-column align-items",
                  `align-items-${messageType === "in" ? "start" : "end"}`
                )}
              >
                <div className="d-flex align-items-center mb-2">
                  {messageType === "in" ? (
                    <>
                      <div className="ms-3">
                        <a
                          href="#"
                          className="fs-5 fw-bolder text-gray-900 text-hover-primary me-1 text-capitalize"
                        >
                          {+user.user.id! === receipient.id
                            ? sender.firstname
                            : receipient.firstname}
                          {/* {user.user.user_type_id === UserTypeId.INVESTOR && sender.firstname} */}
                        </a>
                        <span className="text-muted fs-7 mb-1">
                          {formatTime(message.created_at)}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="me-3">
                        <span className="text-muted fs-7 mb-1">
                          {formatTime(message.created_at)}
                        </span>
                        <a
                          href="#"
                          className="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1"
                        >
                          You
                        </a>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={clsx(
                    "p-5 rounded",
                    `bg-light-${state}`,
                    "text-dark fw-bold mw-lg-400px",
                    `text-${messageType === "in" ? "start" : "end"}`
                  )}
                  // style={{ whiteSpace: "pre" }}
                  data-kt-element="message-text"
                  dangerouslySetInnerHTML={{ __html: message.content }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="" id="kt_chat_messenger_footer">
        <textarea
          className="form-control form-control-flush mb-3"
          rows={1}
          data-kt-element="input"
          placeholder="Type a message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={onEnterPress}
        ></textarea>

        <div className="d-flex flex-stack">
          <div className="d-flex align-items-center me-2">
            <button
              className="btn btn-sm btn-icon btn-active-light-primary me-1"
              type="button"
              data-bs-toggle="tooltip"
              title="Attachments"
              onClick={() => openFileSelector()}
            >
              <i className="bi bi-paperclip fs-3"></i>
            </button>
          </div>
          <button
            className="btn btn-primary btn-sm"
            type="button"
            data-kt-element="send"
            onClick={sendMessage}
          >
            {submitting ? <LoadingIndicator message="" /> : "Send"}
          </button>
        </div>
        {filesContent.map((file, index) => (
          <div
            key={index}
            className="p-2 d-flex flex-row me-2 mt-2 rounded-1 align-items-center"
            style={{
              width: "fit-content",
              gap: "8px",
              backgroundColor: "hsl(240deg 20% 20%)",
            }}
          >
            <p style={{ margin: "0px", color: "#fafafa" }}>{file.name}</p>
            <i className="bi bi-x"></i>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatInner;
